import { createApp } from 'vue';
import Vuelidate from '@vuelidate/core';
import VueScrollTo from 'vue-scrollto';
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import VueGtag from 'vue-gtag-next';
import 'v-calendar/dist/style.css';
import VCalendar from 'v-calendar';
import App from './App.vue';
import axios from './plugins/axios';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import { applyCSSVariables } from './constants/color';

// color.jsで定義した色をCSS変数として適用
applyCSSVariables();

// 学校/企業管理者サイト(/teacher 配下)はヘッダー帯を青で初回ペイント前に確定する。
// account_type は loginCheck(非同期)解決まで未定なので、同期確定する URL(pathname) を信号にし、
// オレンジ(既定)→青 のちらつきを防ぐ #3185
if (window.location.pathname.startsWith('/teacher')) {
  document.documentElement.style.setProperty('--header-band-color', 'var(--school-admin-header-color)');
}

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store);
app.use(router);
app.use(Vuelidate);
app.use(VueScrollTo);
app.use(VueGtag, {
  property: {
    id: 'G-RCG4SMZHDF',
    router,
  },
});
app.use(VCalendar, {});
app.mount('#app');
